import { Component, OnInit, Inject, Input, Output } from '@angular/core';

import {FormBuilder, FormGroup, Validators} from '@angular/forms';

import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import { SelectedAssuranceComponent } from '../selected-assurance/selected-assurance.component';

import { CustomParameterComponent } from '../custom-parameter/custom-parameter.component';

import { ServicepoolService } from '../services/servicepool.service';

import { ReponseWebService } from '../datastruct/Meloyi.module';

import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';

import { ConfirmsouscriptionComponent } from '../confirmsouscription/confirmsouscription.component';

import { ViewChild, TemplateRef } from '@angular/core';

import {MatProgressBarModule} from '@angular/material/progress-bar';


export interface Parametre {
  nomFrmt : string; 
  type : "simple" ;
  intitule: string;
}

export interface Garantie {
  nomFrmt : string; 
  intitule: string;
  params: Parametre[];
  formule: any[];
  mandatory :  boolean ;
}

export interface Categorie {
  nomFrmt : string; 
  intitule: string;
  garanties: Garantie[]
}

export interface Insurance {
  nomFrmt : string; 
  intitule: string;
  policy: boolean ;
  categs: Categorie[]
}



@Component({
  selector: 'app-sav',
  templateUrl: './sav.component.html',
  styleUrls: ['./sav.component.css']
})
export class SavComponent implements OnInit {

  rcTabval  = 0 ;
  dtTabval  = 0 ;
  vlTabval  = 0 ;
  incTabval = 0 ;
  bglTabval = 0 ;
  srTabval  = 0 ;


  requireMatricule = false ;


  askedParams = [] ;
  askedParamsValues = [] ;

  askedPredefCustParams = [] ;
  askedPredefCustParamsValues = [] ;

  mtric : string  ;

  allDevis : any ;

  infoscar : any ;
  
  params = [] ;
  paramsNames = [] ;
  paramsValues = [] ;

  allgarantie = [] ;

  toggle = [] ;
  verroux = [] ;

  retourClientWS  : ReponseWebService ;

  activeChoice = 0 ;

  selectedValue = "" ;

  newcateg = "" ;

  createnewcatg = 0 ;

  addsaveicon = "add" ;

  currentInsuranceCategs = [] ;

  currentCateg = "" ;
  currentCategConfig = "" ;

  currentInsurance = "" ;
  globalInsuranceConfig = "" ;

  canAdd = false ;


  addPrm = 0 ;


  choosencompagnieID = 0 ;

  choosencompagnieName = "" ;

  primarycolor = "primary" ;//"#3f51b5" ;

  vientDechooseCompagnie = 1 ;

  allTheCompagnies: any ;



  newGarantie = "" ;

  lesAssurances = [] ;
  lesCategsParAssurance = [] ;



  allInsurancesTypes =  [] ;// [{"intitule": "Assurance Auto", "icon":"iconeassuranceauto"}] ;

  choosenInsuranceType : any ;


  allBigCategories = [] ; /*[{"idcateg": "1", "categorie": "CAT 1", "denommintation":"TOURISME", 
                        "abreviation":"VPCI", 
                        "description":"VEHICULE PERSONNEL POUR USAGE PERSONNEL",
                        "soustypes":["BERLINE", "CAMIONNETTE", "PICK-UPS", "REMORQUE"]}] ;*/


  choosenBigCateg : any ;



  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  isEditable = false;

  primeParams = [] ;
  nomsPrimes = [] ;
  configPrimes = [] ;
  primesOpt = [] ;


  allInsurances = [] ;
  currentCategGaranties = [] ;
  choosedInsuranceIndex = -1 ;
  choosedCategoryIndex = -1 ;


  @ViewChild('spinnerDialog') spinnerDialog: TemplateRef<any>;

  spinnerDialogRef : any ;



  constructor(public dialog: MatDialog,  private configServer: ServicepoolService) {}

  ngOnInit(): void {
      this.getAllCompagnies() ;    
      this.getAllInsuranceTypes() ;    
  }


  getAllCompagnies(){
    console.log("Here we go !!!") ;
    this.configServer.getAllCompagnies("thiswii").then( (retourbi) => {
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;
      console.log(this.retourClientWS.data) ;
      if(statutreq==1){
        console.log("Done") ;
        this.allTheCompagnies = this.retourClientWS.data ; 
      }
      else{
        console.log("Failed") ;
      }
    }) ;    
  }


  taneBenCompagnie(oneidComp, indexcompagnie){
    this.choosencompagnieID = oneidComp ;
    this.choosencompagnieName = this.allTheCompagnies[indexcompagnie].nomcompagnie ;
    this.vientDechooseCompagnie = 1 ;
    this.activeChoice = 0 ;

    this.canAdd = false ;     
    this.currentInsuranceCategs = [] ;
    this.choosedInsuranceIndex = -1 ;

    this.choosenInsuranceType = undefined ;
    //this.getAllConfigs();
  }


  getAllInsuranceTypes(){
    console.log("Here we go 148 !!! ") ;
    this.configServer.getAllInsuranceTypes("thiswii").then( (retourbi) => {
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;
      console.log(this.retourClientWS.data) ;
      if(statutreq==1){
        console.log("Done") ;
        this.allInsurancesTypes = this.retourClientWS.data ; 
      }
      else{
        console.log("Failed") ;
      }
    }) ;    
  }



  getAllBigCategories(){
    console.log("Here we go 187 !!! ") ;
    this.configServer.getAllBigCategories("thiswii", this.choosenInsuranceType.raniee).then( (retourbi) => {
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;
      console.log(this.retourClientWS.data) ;
      if(statutreq==1){
        console.log("Done") ;
        this.allBigCategories = this.retourClientWS.data ; 
      }
      else{
        console.log("Failed") ;
      }
    }) ;    
  }


  getThePrimaryColor(idInCompagnie){
    console.log("There i am ") ;
    let valuReturn = this.choosencompagnieID==idInCompagnie ? this.primarycolor:'' ;
    console.log(valuReturn) ;

    return valuReturn ;

  }


  soppiMbirrMi(domaine){

    if (domaine=="rc")
      this.rcTabval = (this.rcTabval==1)? 0:1 ;
    if (domaine=='dt')
      this.dtTabval = (this.dtTabval==1)? 0:1 ;
    if (domaine=='vl')
      this.vlTabval = (this.vlTabval==1)? 0:1 ;
    if (domaine=='inc')
      this.incTabval = (this.incTabval==1)? 0:1 ;
    if (domaine=='bgl')
      this.bglTabval = (this.bglTabval==1)? 0:1 ;
    if (domaine=='sr')
      this.srTabval = (this.srTabval==1)? 0:1 ;
  }

  ajouterPrime(){
    var newLength = this.allInsurances[this.choosedInsuranceIndex].categs[this.choosedCategoryIndex].garanties.push({"nomFrmt": this.formatThisString(this.newGarantie), "intitule": this.newGarantie, "params": [{"nomFrmt":"Franchise", "intitule": "Franchise"}], "formule": [], "mandatory": false }) ;

    sessionStorage.setItem('allinsurances', JSON.stringify(this.allInsurances)) ;
    console.log(this.allInsurances) ;

    //this.currentCategGaranties.push({"nomFrmt": this.formatThisString(this.newGarantie), "intitule": this.newGarantie, "params": [{"nomFrmt":"Franchise", "intitule": "Franchise"}], "formule": [], "mandatory": false })
    this.newGarantie = "" ;
  }

  weShallRemoveThis(eventValue, index){

    var closureOrder = JSON.parse(eventValue).ordre ;

    console.log(JSON.parse(eventValue) ) ;
    console.log("(((((((((((index)))))))))))") ;
    console.log(index) ;

    if( JSON.parse(eventValue).ordre == "fermer"){
      console.log("Là pour fermer") ;
      this.allInsurances[this.choosedInsuranceIndex].categs[this.choosedCategoryIndex].garanties.splice(index, 1)  ;
    }else{
      this.allInsurances[this.choosedInsuranceIndex].categs[this.choosedCategoryIndex].garanties[index] = JSON.parse(eventValue).garantie ;
      sessionStorage.setItem('allinsurances', JSON.stringify(this.allInsurances)) ;
      console.log(this.allInsurances) ;      
    }
  }


  choosedInSelectInsType(slctdInsType){
    if(slctdInsType=="new001one"){
      this.choosenInsuranceType = undefined ;
      //this.openDialogNewInsuranceType() ;
    }
    else{
      this.choosenInsuranceType  = this.allInsurancesTypes[slctdInsType] ;
      this.getAllBigCategories() ;
      //this.getAllConfigs();
    }
  }



  choosedInSelectCateg(slctdInsType){
    if(slctdInsType=="new001one"){
      this.choosenBigCateg = undefined ;
      //this.openDialogNewBigCateg() ;
    }
    else{
      this.choosenBigCateg  = this.allBigCategories[slctdInsType] ;
      this.getAllConfigs();
    }
  }




  selectedOrCreateAssurance(event){
    console.log(this.selectedValue) ;
    this.activeChoice = 0 ;
    if(event.value!="-"){
      if(event.value=="new001one"){
        this.canAdd = false ;     
        this.currentInsuranceCategs = [] ;
        this.choosedInsuranceIndex = -1 ;
        this.openDialogNewAssurance(-1) ;
      }
      else{
        this.canAdd = true ;     
        console.log("117") ;
        this.currentInsurance = this.lesAssurances[event.value] ;
        console.log("120") ;
        //this.currentInsuranceCategs  =  this.lesCategsParAssurance[event.value] ;              
        this.currentInsuranceCategs = this.allInsurances[event.value].categs ;
        console.log("122") ;
        this.choosedInsuranceIndex = event.value ;
        this.openDialogNewAssurance(event.value) ;        
      }
    }else{
        this.choosedInsuranceIndex = -1 ;
        this.canAdd = false ;     
        this.currentInsuranceCategs = [] ;      
    }
  }

  openDialogNewAssurance(indice){

    var data : any ;

    if(indice==-1)
     data = {"assurName": "",  "policy":false, "categs": [{"nomFrmt":this.formatThisString("Aucune Distinction"), "intitule":"Aucune Distinction", "garanties": []}] } ;
    else
     data = {"assurName": this.allInsurances[indice].intitule, "policy":this.allInsurances[indice].policy, "categs": this.allInsurances[indice].categs } ;


   console.log(data) ;
   console.log(this.allInsurances[indice]) ;
    const dialogRef = this.dialog.open(SelectedAssuranceComponent, {data});
    
    dialogRef.afterClosed().subscribe(result => {

      var retourDialog =  {"nomassurance": "", "categs": [], "policy":false} ;

      if ( result==undefined || result==""  )
          retourDialog = {"nomassurance": data.assurName, "categs": data.categs, "policy":retourDialog.policy } ;
      else
          retourDialog = JSON.parse(result) ;

      if(retourDialog.nomassurance!=""){
        if(retourDialog.nomassurance!="*"){
          if(indice==-1){
            this.allInsurances.push({"nomFrmt": this.formatThisString(retourDialog.nomassurance), "intitule": retourDialog.nomassurance, "policy":retourDialog.policy, "categs": retourDialog.categs }) ;
            sessionStorage.setItem('allinsurances', JSON.stringify(this.allInsurances)) ;
          }else{
            console.log("167") ;
            this.allInsurances[this.choosedInsuranceIndex].nomFrmt = this.formatThisString(retourDialog.nomassurance) ;
            this.allInsurances[this.choosedInsuranceIndex].intitule = retourDialog.nomassurance  ;
            this.allInsurances[this.choosedInsuranceIndex].policy = retourDialog.policy  ;
            this.allInsurances[this.choosedInsuranceIndex].categs = retourDialog.categs ;
            this.canAdd = true ;
            sessionStorage.setItem('allinsurances', JSON.stringify(this.allInsurances)) ;
            console.log("173") ;
          }
        }
        else{
          if(indice!=-1){
            this.allInsurances.splice(this.choosedInsuranceIndex, 1)  ;
            this.choosedInsuranceIndex = -1 ;
            sessionStorage.setItem('allinsurances', JSON.stringify(this.allInsurances)) ;
          }
        }
      }

    });
  }

  addorSavenewCateg(){
    if(this.createnewcatg==0){
      this.createnewcatg = 1 ;
      this.addsaveicon = "done" ;
    }else{
      if(this.newcateg!="")
        this.currentInsuranceCategs.push(this.newcateg) ;

      this.newcateg = "" ;
      this.createnewcatg = 0 ;
      this.addsaveicon = "add" ;      
    }
  }

  formatThisString(name){

    return name.replace(/\s+/g, '').normalize('NFD').replace(/[\u0300-\u036f]/g, "") ;
  }

  getCategsFrom(categsNames){
    var returnedValues = [] ;
    for (var i = 0 ; i <categsNames.length; i++) {
      var aCategorie = {"nomFrmt":this.formatThisString(categsNames[i]), "intitule": categsNames[i], "garanties": []} ;
      returnedValues.push(aCategorie) ;
    }

    return returnedValues ;
  }

  configEnsForcateg(index){
    this.currentCateg =  this.currentInsuranceCategs[index].intitule ;    
    this.currentCategGaranties = this.currentInsuranceCategs[index].garanties ;
    this.choosedCategoryIndex = index ;
    this.activeChoice = 1 ;

    this.requireMatricule = false ;
    this.askedParams = [] ;    
    this.askedPredefCustParams = [] ;
    this.askedParamsValues = [] ;    
    this.askedPredefCustParamsValues = [] ;
    this.paramsNames = [] ;
    this.allgarantie = [] ;

    for (var i = 0 ; i <this.currentCategGaranties.length; i++) {
      this.toggle[i] = false ;
      this.verroux[i] = false ;
      if(this.currentCategGaranties[i].mandatory==true){
        this.goOneForThis(i) ;
        this.verroux[i] = true ;
      }
    }

  }

  sauvegarderAssurance(){  

    var nomassurance = this.allInsurances[this.choosedInsuranceIndex].nomFrmt ;
    var configToSave = JSON.stringify(this.allInsurances[this.choosedInsuranceIndex]) ;

    var data = {"title": "Enregistrement Information", "message": "Voulez-vous vraiment enregistrer cette configuration ?"} ;
    const dialogRef1 = this.dialog.open(ConfirmationDialogComponent, {data});
    
    dialogRef1.afterClosed().subscribe(result => {
      console.log(result) ;
      if(result=="dlt"){
        this.configServer.updateConfig(1, configToSave, nomassurance, '').then( (retourbi) => {
            this.retourClientWS = retourbi ;
            var statutrec = this.retourClientWS.statutreq ;
            var message = this.retourClientWS.message ;
            if(statutrec==1)
              console.log("Done") ;
            else
              console.log("Failed") ;
        }) ;        
      }
      else{
        console.log("") ;        
      }
    });
  }


  getAllConfigs(){  
    /*this.configServer.getAllConfigs(this.choosencompagnieID, this.choosenInsuranceType.raniee).then( (retourbi) => {
        this.retourClientWS = retourbi ;
        var statutrec = this.retourClientWS.statutreq ;
        console.log(this.retourClientWS) ;
        this.allInsurances = [] ;

        if(statutrec==1){
          console.log("Done") ;
          var data = JSON.parse(this.retourClientWS.data) ;          
          for (var i = 0 ; i <data.length; i++) {
            if(JSON.parse(data[i].config).policy==false)
              this.allInsurances.push(JSON.parse(data[i].config) ) ;
          }
        }
        else
          console.log("Failed") ;
    }) ;*/    
  }








  choosedInSelectParam(slctd, choosedVal){
    this.askedPredefCustParamsValues[slctd] = choosedVal ;
  }



  choosedInSelect(slctd){
    
    this.activeChoice = 0 ;
    if(slctd=="new001one"){
      this.canAdd = false ;     
      this.currentInsuranceCategs = [] ;
      this.choosedInsuranceIndex = -1 ;
      this.openDialogNewAssurance(-1) ;
    }
    else{
        this.canAdd = true ;     
        this.currentInsurance = this.lesAssurances[slctd] ;
        this.currentInsuranceCategs = this.allInsurances[slctd].categs ;
        this.choosedInsuranceIndex = slctd ;
      }    
  }


  openDialogNewPredefCustom(){

    const dialogRef = this.dialog.open(CustomParameterComponent, {});    
    dialogRef.afterClosed().subscribe(result => {});
  }

  goOneForThis(ind){

    if(this.verroux[ind] == false){
      this.toggle[ind] = !this.toggle[ind];
      if(this.toggle[ind] == true){
        let potentialParams = this.allInsurances[this.choosedInsuranceIndex].categs[this.choosedCategoryIndex].garanties[ind].params ;
        this.allgarantie.push(this.allInsurances[this.choosedInsuranceIndex].categs[this.choosedCategoryIndex].garanties[ind].nomFrmt) ;

        console.log(potentialParams) ;
        for (var i = 0 ; i < potentialParams.length; i++) {
          if(potentialParams[i].type=="predefvehiv"){
              console.log("Has a PredefVehic ") ;

              if(!this.isalreadyIn(this.params, potentialParams[i]) ){
                this.params.push(potentialParams[i]) ;
              }                    

              if ( !this.paramsNames.includes(potentialParams[i].nomFrmt))
                this.paramsNames.push(potentialParams[i].nomFrmt) ;

              this.requireMatricule = true ;
          }
          if(potentialParams[i].type=="simple"){

            if(!this.isalreadyIn(this.params, potentialParams[i]) ){
              this.params.push(potentialParams[i]) ;
            }                    
            if ( !this.paramsNames.includes(potentialParams[i].nomFrmt)){
                this.paramsNames.push(potentialParams[i].nomFrmt) ;
                this.askedParams.push(potentialParams[i]) ;
                this.askedParamsValues.push("") ;
              }
          }
          if(potentialParams[i].type=="custompredef"){
              if(!this.isalreadyIn(this.params, potentialParams[i]) ){
                this.params.push(potentialParams[i]) ;
              }                    
            if ( !this.paramsNames.includes(potentialParams[i].nomFrmt)){
              this.paramsNames.push(potentialParams[i].nomFrmt) ;
              this.askedPredefCustParams.push(potentialParams[i]) ;
              this.askedPredefCustParamsValues.push("") ;
            }
          }
          if(potentialParams[i].type=="recurrent"){
              let allRemoteParams = this.configServer.getAllParamRecurrent(1, potentialParams[i].nomFrmt).then( (retourbi) => {
                  this.retourClientWS = retourbi ;
                  var statutrec = this.retourClientWS.statutreq ;

                  if(statutrec==1){
                    let data = this.retourClientWS.data ;  
                    for (var i = 0 ; i <data.length; i++) {

                        if(!this.isalreadyIn(this.params, data[i]) ){
                          this.params.push(data[i]) ;
                        }                    

                        if(data[i].type=="predefvehiv"){
                          console.log("Inside") ;
                          if ( !this.paramsNames.includes(data[i].nomFrmt)){
                              this.paramsNames.push(data[i].nomFrmt) ;
                           }
                            this.requireMatricule = true ;
                        }
                        if(data[i].type=="simple"){
                          if ( !this.paramsNames.includes(data[i].nomFrmt)){
                            this.paramsNames.push(data[i].nomFrmt) ;
                            this.askedParams.push(data[i]) ;
                            this.askedParamsValues.push("") ;
                          }
                        }
                        if(data[i].type=="custompredef"){
                          if ( !this.paramsNames.includes(data[i].nomFrmt)){
                            this.paramsNames.push(data[i].nomFrmt) ;
                            this.askedPredefCustParams.push(data[i]) ;
                            this.askedPredefCustParamsValues.push("") ;
                          }
                        }
                    }
                      console.log("Params Names :") ;
                      console.log(this.paramsNames) ;
                  }
                  else
                    console.log("Failed") ;
              }) ;    
          }    
        }
      }else{
        for (var i = 0 ; i <this.allgarantie.length; i++) {
          console.log("Removing ...") ;
          if(this.allgarantie[i].nomFrmt==this.allInsurances[this.choosedInsuranceIndex].categs[this.choosedCategoryIndex].garanties[ind].nomFrmt){
            this.allgarantie.splice(i, 1);
          }
        }
      }

    }

  }


  calcDevis(){
    this.mtric = this.mtric.replace(/ /g, "");
    console.log(this.mtric) ;
    let matricule = this.mtric ;
    let duree = 1 ;
    let nomAssurance =  this.allInsurances[this.choosedInsuranceIndex].nomFrmt ;
    let nomCateg =  this.allInsurances[this.choosedInsuranceIndex].categs[this.choosedCategoryIndex].nomFrmt ;



    this.openSpinnerDialog();

    for (var i = 0 ; i <this.askedParamsValues.length; i++) {
      let cle = this.askedParams[i].nomFrmt ;
      let val = this.askedParamsValues[i] ;
      this.paramsValues.push({"nomFrmt": cle, "val": val}) ;
    }
    for (var i = 0 ; i <this.askedPredefCustParams.length; i++) {
      let cle = this.askedPredefCustParams[i].nomFrmt ;
      let val = this.askedPredefCustParamsValues[i] ;
      this.paramsValues.push({"nomFrmt": cle, "val": val}) ;
    }


    this.configServer.getDevis("1", nomAssurance, nomCateg, this.allgarantie, 
          matricule, duree, this.params, this.paramsValues,
          this.choosencompagnieID, this.choosenInsuranceType.raniee, this.choosenBigCateg.idcateg).then( (retourbi) => {
        this.retourClientWS = retourbi ;
        var statutrec = this.retourClientWS.statutreq ;
        console.log(this.retourClientWS) ;

        if(statutrec==1){
      
          this.closeSpinnerDialog() ;

          console.log("Done") ;
          let devisTotal = 0 ;
          this.allDevis = this.retourClientWS.data.devis ;          
          this.infoscar = this.retourClientWS.data.infoscar ;          
          for (var i = 0 ; i <this.allDevis.length; i++) {
            devisTotal = devisTotal +this.allDevis[i].devis ;
          }
          console.log(this.allDevis) ;
          console.log(this.infoscar) ;
          console.log("Devis Total : "+devisTotal) ;

          this.openDialogConfirmSouscription(devisTotal, nomAssurance, nomCateg, matricule, duree, this.paramsValues) ;

        }
        else
          console.log("Failed") ;
    }) ;    

  }  

  isalreadyIn(tabBi, data){
    for (var i = tabBi.length - 1; i >= 0; i--) {
      if (tabBi[i].nomFrmt==data.nomFrmt )
        return true;
    }
    return false ;
  }

  openDialogConfirmSouscription(devisTotal, nomAssurance, nomCateg, matricule, duree, paramsValues) {

    var data = {"infoscar": this.infoscar, "alldevis":this.allDevis, 
                "total" : devisTotal, "nomAssurance" : nomAssurance, 
                "nomCateg" :nomCateg, "matricule": matricule, "duree": duree, "paramsValues": paramsValues } ;
    const dialogRef = this.dialog.open(ConfirmsouscriptionComponent, {data, disableClose: true});

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }




  openSpinnerDialog() {
    this.spinnerDialogRef = this.dialog.open(this.spinnerDialog);
  }

  closeSpinnerDialog() {
    this.spinnerDialogRef.close();
  }


}

